import React, { useCallback } from 'react';

import {
  CreateBase,
  SaveButton,
  SimpleForm,
  useNotify,
  useRefresh,
} from 'react-admin';

import {
  Dialog,
  Box,
  Button,
  Typography,
  IconButton,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

import { upperFirst } from 'lodash';

import { useFormContext } from 'react-hook-form';
import useDialogStatus from '../../../hooks/useDialogStatus';
import errorNotification from '../../../utilities/errorNotification';

const CustomToolbar = () => {
  const { formState: { isValid } } = useFormContext();

  return (
    <Box display="flex" justifyContent="space-between" gap={2} marginTop={6}>
      <SaveButton
        disabled={!isValid}
        icon={undefined}
      />
    </Box>
  );
};

const CreateDialog = ({ title, children }: {title: string; children: React.ReactElement }) => {
  const { open, openDialog, closeDialog } = useDialogStatus();
  const notify = useNotify();
  const refresh = useRefresh();

  const onSuccess = useCallback(() => {
    notify(`${upperFirst(title)} created`);
    closeDialog();
    refresh();
  }, [closeDialog, notify, refresh, title]);

  const onError = useCallback((e: unknown) => {
    notify(errorNotification(e), { type: 'error' });
  }, [notify]);

  return (
    <Box>
      <Button startIcon={<AddIcon />} size="small" onClick={openDialog}>Create</Button>
      <Dialog open={open} onClose={closeDialog} fullWidth>
        <Box display="flex" alignItems="center" justifyContent="space-between" padding={4} paddingBottom={0}>
          <Typography variant="largeTitle">{`Create new ${title}`}</Typography>
          <IconButton onClick={closeDialog}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <CreateBase mutationOptions={{ onSuccess, onError }}>
          <Box padding={4}>
            <SimpleForm mode="all" toolbar={<CustomToolbar />} component={Box}>
              {children}
            </SimpleForm>
          </Box>
        </CreateBase>
      </Dialog>
    </Box>
  );
};

export default CreateDialog;
